var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.17 8a3.001 3.001 0 0 1 5.66 0H21a1 1 0 1 1 0 2H10.83a3 3 0 0 1-5.66 0H3a1 1 0 1 1 0-2zM8 10a1 1 0 1 0 0-2 1 1 0 0 0 0 2m10.83 5H21a1 1 0 0 1 0 2h-2.17a3 3 0 0 1-5.66 0H3a1 1 0 1 1 0-2h10.17a3 3 0 0 1 5.66 0M16 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2",
  clipRule: "evenodd"
})));
export default SvgFilter;